import { Link, Navigate, useParams } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import useSiteMeta from "@/hooks/useSiteMeta";
import { SITE } from "@/site";
import { getBlogPost } from "@/data/blog";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import ScrollToTop from "@/components/ui/ScrollToTop";

export default function BlogPostPage() {
  const { slug } = useParams();
  const { lang } = useLang();
  const post = getBlogPost(slug);

  const metaOverrides = post
    ? {
        ...post.meta[lang],
        canonical: `${SITE.url}/blog/${post.slug}`,
        ogTitle: post.meta[lang].title,
        ogDescription: post.meta[lang].description,
      }
    : {};

  useSiteMeta(lang, metaOverrides);

  if (!post) return <Navigate to="/blog" replace />;

  return (
    <div className="bg-navy-deep text-white-warm min-h-screen">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 lg:px-20 pt-32 pb-24">
        <Link to="/blog" className="font-mono text-[10px] tracking-[0.28em] uppercase text-ice/70 hover:text-ice transition-colors">
          ← Blog
        </Link>

        <time className="font-mono text-[10px] tracking-[0.2em] uppercase block mt-10" style={{ color: "rgba(242,232,216,0.35)" }}>
          {post.date}
        </time>
        <h1 className="font-display font-light text-white-warm mt-4 leading-tight" style={{ fontSize: "clamp(2rem, 4.5vw, 3.2rem)" }}>
          {post.title[lang]}
        </h1>

        <div className="mt-10 space-y-6">
          {post.body[lang].map((paragraph, i) => (
            <p key={i} className="font-body text-base leading-[1.9]" style={{ color: "rgba(242,232,216,0.72)" }}>
              {paragraph}
            </p>
          ))}
        </div>

        <div className="mt-14 p-8 rounded-lg border border-amber/25 text-center" style={{ background: "rgba(200,121,65,0.04)" }}>
          <p className="font-body text-sm" style={{ color: "rgba(242,232,216,0.6)" }}>
            {lang === "pl" ? "Masz pytanie o swój projekt?" : "Have a question about your project?"}
          </p>
          <Link to="/#kontakt" className="btn-primary inline-flex mt-5">
            {lang === "pl" ? "Napisz do nas →" : "Write to us →"}
          </Link>
        </div>
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}